
import {
  computed,
  defineComponent,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
} from "vue";
import TopBar from "./components/TopBar.vue";
import Statistics from "./components/Statistics.vue";
import Success from "./components/Success.vue";
import KeyBoard from "./components/KeyBoard.vue";
import SettingsPage from "./components/SettingsPage.vue";
import InfoPage from "./components/InfoPage.vue";
import { getTodayWord, getlAllWords, getDate } from "./utils/words";
import Popup from "./components/Popup.vue";
import { board } from "./utils/board";
import FrontTile from "./components/FrontTile.vue";
import { alphab, restOfElphabet1, endLetters } from "./utils/letters";
import { makeguess2 } from "./functions/makeguess2";
import { deleteKey } from "./functions/deleteKey";
import { keyEnter } from "./functions/keyEnter";
import { handlePopUp } from "./functions/handlePopUp";
import { loadFromStorage } from "./functions/loadFromStorage";
interface Attemps {
  first: boolean;
  seconde: boolean;
  third: boolean;
  fourth: boolean;
  fith: boolean;
  six: boolean;
}

interface Layout {
  settings: boolean;
  info: boolean;
  main: boolean;
}
interface B {
  a: number;
  b: number;
}

export default defineComponent({
  name: "App",
  components: {
    TopBar,
    KeyBoard,
    SettingsPage,
    InfoPage,
    Popup,
    Statistics,
    Success,
    FrontTile,
  },
  setup() {
    const wordoftheday1 = ref(getTodayWord()) as any;
    // const wordoftheday = ref("כימאי") as any;
    const wordoftheday = ref(wordoftheday1.value.word) as any;
    // console.log(wordoftheday);
    // console.log("wordoftheday");
    
    const allTheWord = getlAllWords();
    const theDate = ref(wordoftheday1.value.date);
    const word = ref(board());
    const allLetters = reactive([...alphab, ...restOfElphabet1]);
    const finalLetters = reactive(endLetters);
    const layout = reactive({
      settings: false,
      info: false,
      main: true,
    }) as Layout;
    const darkMode = ref(false);
    const currentRowIndex = ref(0) as any;
    const currentRow = computed(() => word.value[currentRowIndex.value]) as any;

    const guess = ref([]) as any;
    const today = new Date().toLocaleDateString("he-IL", {
      timeZone: "Asia/Jerusalem",
    });
    const splitedWord = computed(() => wordoftheday.value.split("")) as any;
    const splitedWordCopy= wordoftheday.value.split("")
    
    
    const duplicatedletters =ref([])
    const guessNum = ref(0);
    const wiggle = reactive({ wiggle: false });
    const statistics = reactive({ statistics: false });
    const success = reactive({ success: false });
    const popUpValue = ref("");
    const gridImage = ref("") as any;
    const firstTimer = ref(false) as any;
    const gamerKeyBoard = reactive({ active: false });
    const keboardDelay = ref(true);
    const toggleOut= ref(false)

    const computedGuess = computed(() => {
      let word1 = "";
      for (let letter of guess.value) {
        word1 += letter;
      }
      return word1;
    });

    let computedKeyBoard = computed(() => {
      let word = [] as any;
      guess.value.forEach((letter: string) => {
        allLetters.forEach((char: any) => {
          if (char.letter === letter) {
            word.push(char);
          }
        });
      });

      return word;
    });

    const toggleDarkMode = () => {
      darkMode.value = !darkMode.value;
    };
    const outToggle= ()=>{
      // console.log("in");
      
      success.success= false
    }

    const removeChar = () => {
      deleteKey(success, currentRow, guess);
    };

    const enterKey = (event: any) => {
      keyEnter(success, currentRow, guess, event, wordoftheday, finalLetters);
    };

    const handlesPopUp = (message: string) => {
      handlePopUp(popUpValue, currentRow, wiggle, message);
    };

    const makeGuess = () => {
      makeguess2(
        keboardDelay,
        computedGuess,
        allTheWord,
        success,
        currentRow,
        guess,
        wordoftheday,
        splitedWord,
        computedKeyBoard,
        currentRowIndex,
        guessNum,
        statistics,
        popUpValue,
        wiggle,
        gridImage,
        today,
        word,
        finalLetters,
        allLetters,
        duplicatedletters,
        splitedWordCopy
      );
    };

    const loadfromLocalStorage = () => {
      loadFromStorage(
        gridImage,
        word,
        currentRowIndex,
        success,
        statistics,
        firstTimer,
        today,
        wordoftheday,
        splitedWord,
        allLetters,
        finalLetters,
        layout
      );
    };

    onBeforeMount(() => {
      loadfromLocalStorage();
    });

    document.body.addEventListener("keydown", function (event) {
      if (
        event.key === "Shift" ||
        event.key === "Alt" ||
        event.key === "Tab" ||
        event.key === "CapsLock" ||
        event.key === "Control"
      )
        return;
      if (event.key === "Backspace") {
        removeChar();
        return;
      }
      if (event.key === "Enter") {
        makeguess2(
          keboardDelay,
          computedGuess,
          allTheWord,
          success,
          currentRow,
          guess,
          wordoftheday,
          splitedWord,
          computedKeyBoard,
          currentRowIndex,
          guessNum,
          statistics,
          popUpValue,
          wiggle,
          gridImage,
          today,
          word,
          finalLetters,
          allLetters
        );
        return;
      }

      enterKey(event);
    });

    return {
      layout,
      word,
      darkMode,
      toggleDarkMode,
      makeGuess,
      popUpValue,
      wordoftheday,
      deleteKey,
      wiggle,
      currentRow,
      statistics,
      success,
      gridImage,
      handlesPopUp,
      computedGuess,
      splitedWord,
      allLetters,
      gamerKeyBoard,
      theDate,
      removeChar,
      enterKey,
      outToggle,
      toggleOut
    };
  },
});
